import React from 'react';
import ScheduleIcon from '@material-ui/icons/Schedule';
import dayjs from 'dayjs';
import CaPicker from 'src/components/Inputs/CaPicker/index';
function TimePicker({ format = 'HH:mm', value = dayjs(), allowClear, minuteStep, showTime, ...rcPickerProps }) {
    return (React.createElement(CaPicker, { picker: "time", showTime: {
            showHour: true,
            showMinute: true,
            showSecond: false,
            minuteStep,
            ...(typeof showTime === 'object' ? showTime : {})
        }, format: format, value: value, allowClear: allowClear, suffixIcon: React.createElement(ScheduleIcon, null), suffixAsInnerIcon: true, ...rcPickerProps }));
}
export default TimePicker;
